/**
 * 模組頁面代碼 : 
 * 頁面說明 : 底部元件
 * @module features/main-frame/Footer.jsx
 */

// ----- import from base components -----
import React from 'react';
import { NavLink } from 'react-router-dom';


const Footer = () => {
    return (
        <footer className="gs18-Footer" role="contentinfo" data-js-gs18-footer>
            <div className="gs18-Footer__Links gs18-Footer__Links--withme">
                <ul className="gs18-Footer__Legal">
                    <li>{/*<a href="/privacy">隱私權政策</a>*/}<NavLink to="/privacy">隱私權政策</NavLink></li>
                    <li>{/*<a href="/copyright">版權所有</a>*/}<NavLink to="/copyright">版權所有</NavLink></li>
                    <li>{/*<a href="/contact">聯絡我們</a>*/}<NavLink to="/contact">聯絡我們</NavLink></li>
                </ul>
                <small className="gs18-Footer__Copyright">© TAIWAN MITSUBISHI ELEVATOR CO., LTD.</small>
            </div>
            {/* <!-- Please write ICP number --> */}
            {/*<p className="gs18-GoTop"><a href="#" data-js-gs18-gotop></a></p>*/}
        </footer>
    );
};

export default Footer;
